import update from 'immutability-helper';
import { createSwitch, createCase } from 'helpers/action-helpers';
import { initialState } from './state';
import {
  LoginAction,
  LogoutAction,
  UserLoggedInAction,
  LoginErrorAction,
  SwitchToBarcodeLoginAction,
  SwitchToUsernameLoginAction,
  BeginLoginAction,
  SetUserPermissionsAction
} from './actions';
import { LoginType } from 'types/login-type';
  
export const loginReducer = createSwitch(initialState, [
  createCase(new BeginLoginAction(), (state, action) => {
    return update(state, {
      isProcessing: { $set: true }
    });
  }),
  createCase(new LoginAction(LoginType.UsernamePassword, '', ''), (state, action) => {
    return update(state, { 
      loginType: { $set: action.loginType },
      isProcessing: { $set: true }
    });
  }),
  createCase(new LogoutAction(''), (state, action) => {
    return update(state, {
      loggedIn: { $set: false },
      username: { $set: '' },
      loginErrorMessage: { $set: '' },
      isProcessing: { $set: false }
    });
  }),
  createCase(new UserLoggedInAction(''), (state, action) => {
    return update(state, {
      loggedIn: { $set: true },
      loginErrorMessage: { $set: '' },
      isProcessing: { $set: false },
      permissions: { $set: action.permissions }
    });
  }),
  createCase(new SetUserPermissionsAction(''), (state, action) => {
    return update(state, {
      loggedIn: { $set: true },
      permissions: { $set: action.permissions }
    });
  }),
  createCase(new LoginErrorAction(''), (state, action) => {
    return update(state, {
      loggedIn: { $set: false },
      loginErrorMessage: { $set: action.loginErrorMessage },
      isProcessing: { $set: false }
    });
  }),
  createCase(new SwitchToBarcodeLoginAction(''), (state, action) => {
    return update(state, {
      loginType: { $set: LoginType.BarcodePin },
      username: { $set: action.epc }
    });
  }),
  createCase(new SwitchToUsernameLoginAction(''), (state, action) => {
    return update(state, {
      loginType: { $set: LoginType.UsernamePassword },
      username: { $set: action.username }
    });
  })
]);


// WEBPACK FOOTER //
// ./src/pages/login/reducer.ts